module.exports = __webpack_public_path__ + "img/shared-2.318da0a2.jpg";